<template>
  <div class="mapbox">
    <div class="closebtn" @click="$emit('goBack')">关闭 ×</div>
    <!-- <img :src="currentImage" class="detail-img" /> -->
    <div class="imgbox">
      <img v-for="(img, i) in images" :key="i" :src="img" class="image" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeliveryDetail',

  //接收图片index参数
  props: {
    deliveryImageIndex: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      images: [
        require('../assets/images/delivery/store1.png'),
        require('../assets/images/delivery/store2.png')
      ]
    }
  },

  computed: {
    currentImage() {
      return this.images[this.deliveryImageIndex]
    }
  }
}
</script>

<style scoped>
.mapbox {
  display: flex;
  height: 100%;
  padding: 16px;
  gap: 12px;
  flex-direction: column;
}

.closebtn {
  color: #83ffe1;
  text-align: right;
  margin: 20px 15px;
  cursor: pointer;
}

.detail-img {
  width: 100%;
  height: 80%;
  object-fit: fill;
  border-radius: 8px;
  padding: 15px 20px;
}

.imgbox {
  display: flex;
  align-items: center;
  height: 80%;
  padding: 0 15px;
}

.image {
  /* height: 100%; */
  width: 50%;
}
</style>
